export const DOWNLOAD_REPORT_SUCCESS = 'DOWNLOAD_REPORT_SUCCESS';

export const downloadReportSuccess = report => ({
    type: DOWNLOAD_REPORT_SUCCESS,
    payload: { report },
});
